import './TableExpertMode.styles.scss';

import { observer } from 'mobx-react';
import React, { FC, useEffect, useMemo } from 'react';

import tableStore from '../../../store/TableStore';
import Game from '../../Game/Game';
import TableHeader from '../../Game/TableHeader/TableHeader';
import { buttonTypesExpertMode } from '../../shared/Button/TableButton.types';
import BotChatMessageExpertMode from '../BotChatMessageExpertMode/BotChatMessageExpertMode';

const TableExpertMode: FC = () => {
  const selectedTableId = tableStore.viewingTableIds[0];

  const selectedTable = useMemo(
    () => tableStore.getActiveTableById(selectedTableId),
    [selectedTableId, tableStore.activeTables, tableStore.activeTables.size],
  );

  useEffect(() => {
    if (tableStore.viewingTableIds.length > 1) {
      tableStore.viewingTableIds.forEach((tableId, index) => {
        if (index === 0) {
          return;
        }
        tableStore.removeViewingTable(tableId);
      });
    }
  }, [tableStore.viewingTableIds.length]);

  return (
    <div className="TableExpertMode-Component multitables-container">
      {tableStore.viewingTableIds.length === 1 && selectedTable && (
        <div className="table-expert-mode">
          <TableHeader table={selectedTable} buttons={buttonTypesExpertMode} />
          <Game tableId={selectedTableId} />
        </div>
      )}
      {selectedTable && <BotChatMessageExpertMode table={selectedTable} />}
    </div>
  );
};

export default observer(TableExpertMode);
